if (!customElements.get("notify-me-modal")) {
  class NotifyMeModal extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector(".notify-me-modal__overlay");
      this.form = this.querySelector(".notify-me-modal__form");
      this.emailInput = this.querySelector('[name="notify-email"]');
      this.phoneInput = this.querySelector('[name="notify-phone"]');
      this.errorEl = this.querySelector(".notify-me-modal__error");
      this.submitBtn = this.querySelector(".notify-me-modal__submit");
      this.successEl = this.querySelector(".notify-me-modal__success");
      this.subtitleEl = this.querySelector(".notify-me-modal__subtitle");
      this.variantInfoEl = this.querySelector(".notify-me-modal__variant-info");
      this.closeBtn = this.querySelector(".notify-me-modal__close");

      this.sheetUrl = this.dataset.sheetUrl || "";
      this.productTitle = this.dataset.productTitle || "";
      this.storeUrl = this.dataset.storeUrl || "";
      this.currentVariantTitle = "";

      this.bindEvents();
    }

    bindEvents() {
      this.closeBtn.addEventListener("click", () => this.close());
      this.overlay.addEventListener("click", (e) => {
        if (e.target === this.overlay) this.close();
      });
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.handleSubmit();
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this.close();
      });
    }

    open(variantTitle) {
      this.currentVariantTitle = variantTitle || "";
      if (this.variantInfoEl) {
        this.variantInfoEl.textContent = this.currentVariantTitle;
      }
      // Reset state
      this.form.classList.remove("is-hidden");
      this.subtitleEl.classList.remove("is-hidden");
      this.successEl.classList.remove("is-visible");
      this.errorEl.classList.remove("is-visible");
      this.emailInput.classList.remove("has-error");
      this.emailInput.value = "";
      this.phoneInput.value = "";
      this.submitBtn.disabled = false;
      this.submitBtn.querySelector(".m-add-to-cart--text").textContent = "Notify Me";

      this.overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
      this.emailInput.focus();
    }

    close() {
      this.overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }

    validate() {
      const email = this.emailInput.value.trim();
      const phone = this.phoneInput.value.trim();

      if (!email && !phone) {
        this.showError("Please enter an email or phone number.");
        this.emailInput.classList.add("has-error");
        return false;
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.showError("Please enter a valid email address.");
        this.emailInput.classList.add("has-error");
        return false;
      }

      this.hideError();
      this.emailInput.classList.remove("has-error");
      return true;
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.classList.add("is-visible");
    }

    hideError() {
      this.errorEl.classList.remove("is-visible");
    }

    async handleSubmit() {
      if (!this.validate()) return;
      if (!this.sheetUrl) {
        this.showError("Notification service not configured. Please contact the store owner.");
        return;
      }

      this.submitBtn.disabled = true;
      this.submitBtn.querySelector(".m-add-to-cart--text").textContent = "Sending...";

      const payload = {
        email: this.emailInput.value.trim(),
        phone: this.phoneInput.value.trim(),
        product_title: this.productTitle,
        variant_title: this.currentVariantTitle,
        timestamp: new Date().toISOString(),
        store_url: this.storeUrl,
      };

      try {
        await fetch(this.sheetUrl, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        // Show success (no-cors means we can't read the response, so assume success)
        this.form.classList.add("is-hidden");
        this.subtitleEl.classList.add("is-hidden");
        this.successEl.classList.add("is-visible");

        setTimeout(() => this.close(), 3000);
      } catch (err) {
        this.showError("Something went wrong. Please try again.");
        this.submitBtn.disabled = false;
        this.submitBtn.querySelector(".m-add-to-cart--text").textContent = "Notify Me";
      }
    }
  }

  customElements.define("notify-me-modal", NotifyMeModal);
}
